/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import CreateIcon from '@material-ui/icons/Create';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withStyles from '@material-ui/core/styles/withStyles';

import { form as FormStyle } from '../../../style/form';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import DesktopCreditCardForm  from '../../../common/ModalContent/Desktop/DesktopCreditCardForm';
import DesktopBillingEditAdress  from '../../../common/ModalContent/Desktop/DesktopBillingEditAdress';
import configENV from '../../../config';

const styles = ({ typography, palette }) => FormStyle(typography, palette);

const {  PERSIST_KEY } = configENV;

class DesktopCardInfo extends PureComponent {
    render() {
        const {
            billingAddress, countries,  modal: { content: wallet }, addNewConfig, handleClickEditBillingAddress, handleDesktopClickEditCreditCard,
        } = this.props;
        const {
            Addresses, FirstName, LastName, PhoneNumber, EmployerName,
        } = billingAddress[0];
        const {
            AddressLineOne, AddressLineTwo, Country, StateProvince, PostalCode, City,
        } = Addresses[0];
        const {
            walletId,  cardHolderName, cardType, expiryDate, lastFourDigits, subsIndicator,
        } = wallet;
        return (
            <div className="mainBillingCard">
                <div className="billLeftSide">
                    { addNewConfig === 'BillingForm'
                        ? (
                            <table className="tableInfo">
                                <tbody>
                                    <tr className="billingTitle">
                                        <th>Card Information</th>
                                        <td aria-hidden onClick={() => handleDesktopClickEditCreditCard(wallet)}><CreateIcon /> Edit</td>
                                    </tr>
                                    <tr>
                                        <th>Name on Card:</th>
                                        <td> {cardHolderName}</td>
                                    </tr>
                                    <tr>
                                        <th>Card Type:</th>
                                        <td>{cardType}</td>
                                    </tr>
                                    <tr>
                                        <th>Card Number:</th>
                                        <td>&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
                                            {lastFourDigits}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Expiration Date:</th>
                                        <td> {expiryDate}</td>
                                    </tr>
                                    <tr>
                                        <th> </th>
                                        <td>{subsIndicator === '1' ? (
                                            <>
                                                <span className="default-card">Default Card</span>
                                                <span className="default-card-info">Used for Subscriptions &amp; Passport renewals</span>
                                            </>
                                        ) : ''}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        )
                        : <DesktopCreditCardForm />}
                </div>
                <div className="billRigthtSide">
                    { addNewConfig === 'BillingForm'
                        ? <DesktopBillingEditAdress />
                        :                        (
                            <table className="tableInfo">
                                <tbody>
                                    <tr className="billingTitle">
                                        <th>Billing Address</th>
                                        {walletId ? (<td aria-hidden onClick={() => handleClickEditBillingAddress(billingAddress, wallet)}><CreateIcon  /> Edit</td>) : <td /> }
                                    </tr>
                                    <tr>
                                        <th>Name:</th>
                                        <td> {FirstName} {LastName}</td>
                                    </tr>
                                    <tr>
                                        <th>Company Name:</th>
                                        <td>{EmployerName}</td>
                                    </tr>
                                    <tr>
                                        <th>Address:</th>
                                        <td>{AddressLineOne}
                                            {AddressLineTwo
                                                ? `, ${AddressLineTwo}`
                                                : ''}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>City, State, Zip Code:</th>
                                        <td> {[
                                            City, StateProvince, PostalCode,
                                        ].join(', ')}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Country</th>
                                        <td> {
                                            countries.filter((c) => c.id === Country)[0].name
                                        }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Phone</th>
                                        <td>{PhoneNumber}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                </div>
            </div>
        );
    }
}

DesktopCardInfo.defaultProps = {
    addNewConfig: '',
    handleDesktopClickEditCreditCard: () => {},
};

DesktopCardInfo.propTypes = {
    billingAddress: PropTypes.array.isRequired,
    countries: PropTypes.array.isRequired,
    modal: PropTypes.object.isRequired,
    addNewConfig: PropTypes.string,
    handleClickEditBillingAddress: PropTypes.func.isRequired,
    handleDesktopClickEditCreditCard: PropTypes.func,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        modal: newState.modal,
        addNewConfig: newState.addNewConfig,
    };
};
const mapDispatchToProps = (dispatch) => ({
    handleClickEditBillingAddress: (address, wallet) => dispatch(EventDispatcher.handleClickEditBillingAddress(address, wallet)),
    handleDesktopClickEditCreditCard: (walletInfo) => dispatch(EventDispatcher.handleDesktopClickEditCreditCard(walletInfo)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopCardInfo));
